var $9746cad167cf365e$exports = {};
$9746cad167cf365e$exports = {
    "collectionLabel": `Forslag`
};


export {$9746cad167cf365e$exports as default};
//# sourceMappingURL=da-DK.module.js.map
